import {
    events,
    on,
    queryProvider,
    serviceQueries,
    commandProvider,
    serviceCommands
} from 'elc-service-bus';
import { SignOutUseCase } from '../internal/use-cases/SignOutUseCase';
import { ClearAuthSessionUseCase } from '../internal/use-cases/ClearAuthSessionUseCase';
import {
    UpdateAuthSessionUseCase,
    IAuthSession
} from '../internal/use-cases/UpdateAuthSessionUseCase';
import { SetEmailUseCase } from '../internal/use-cases/SetEmailUseCase';
import { TokenChangedUseCase } from '../internal/use-cases/TokenChangedUseCase';
import { reaction } from 'mobx';
import { AuthSessionRepository } from '../internal/repositories/AuthSessionRepository';
import { AuthSession } from '../internal/domain/entities/AuthSession';
import { GuestRepository } from '../internal/repositories/GuestRepository';

export class ServiceBusController {
    private authSessionRepository: AuthSessionRepository;
    private authSession: AuthSession;
    private guestRepository: GuestRepository;

    constructor(authSessionRepository: AuthSessionRepository, guestRepository: GuestRepository) {
        this.authSessionRepository = authSessionRepository;
        this.authSession = this.authSessionRepository.authSession;
        this.guestRepository = guestRepository;
        reaction(() => this.authSession.token, this.tokenChanged);
    }

    @queryProvider(serviceQueries.IS_AUTHENTICATED)
    public isAuthenticated = () => {
        return this.authSessionRepository.authSession.isAuthenticated;
    };

    @queryProvider(serviceQueries.GUEST_EMAIL)
    public guestEmail = async () => {
        const guestUser = await this.guestRepository.getGuestUser();

        return guestUser.email;
    };

    @commandProvider(serviceCommands.SET_SIGN_IN_EMAIL)
    public setFormEmail = async ({ email }: { email: string }) => {
        const setEmailUseCase = new SetEmailUseCase(email);
        setEmailUseCase.execute();
    };

    @commandProvider(serviceCommands.AUTH_UPDATE_DATA)
    public updateAccessToken = (payload: IAuthSession) => {
        const useCase = new UpdateAuthSessionUseCase(payload);
        useCase.execute();
    };

    @on(events.UNAUTHORIZED_REQUEST)
    public unauthorizedRequest = () => {
        const useCase = new ClearAuthSessionUseCase(this.authSessionRepository);
        void useCase.execute();
    };

    @on(events.SIGNED_OUT)
    public signedOut = () => {
        const useCase = new SignOutUseCase();
        void useCase.execute();
    };

    public tokenChanged = async () => {
        const useCase = new TokenChangedUseCase();
        await useCase.execute();
    };
}
